import { z } from 'zod'

/*
 * Zod's built-in `.email()` regex is ASCII only, and the institutional mailboxes of our clients are
 * not: `_Pole_SMDPL_Consultation_Psychiatrie_Légale@ch-le-vinatier.fr` is a real, deliverable address
 * that RFC 6531 allows, that their mail server delivers to, and that Cognito accepts as a username.
 *
 * Refusing it was not a harmless strictness. Such an address in the database made `GET /user` answer
 * 500 for the WHOLE company, since one invalid entry fails the response array; every action the person
 * was responsible for became unreadable too; and the login form would not even let them type it.
 *
 * So the local part accepts anything but whitespace and `@`, while the domain stays deliberately
 * strict — labels of letters, digits and hyphens, and a TLD of at least two letters. Leading, trailing
 * and doubled dots are rejected, which is what keeps `pas-une-adresse` and `a..b@c.fr` out.
 */
export const MAIL_REGEX = /^(?!\.)(?!.*\.\.)[^\s@]+(?<!\.)@([a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/iu

/* The message overload exists for the web forms, which show a translated error. */
export const mailSchemaWithMessage = (message: string) => z.string().trim().regex(MAIL_REGEX, message)

export const mailSchema = mailSchemaWithMessage('Invalid email')
